/**
 * This file is largely copied into `/assets/wf/js/educators.wf.js` (see that file
 * for more info). If a change needs to be made to this copy, it needs to be
 * reflected there as well (and vice versa).
 */

/**
 * NOTE: Submissions of this modal do go through to Salesforce, even on development
 * environments.
 * NOTE: The redirect back to our page doesn't work on local machines. If you need
 * fully test submissions of this modal, you'll need to try it on a remote test
 * server.
 */

const openModal = modalClass => {
	const el = document.querySelector(`.${modalClass}`);
	el.style.display = "flex";
	setTimeout(() => (el.style.opacity = 1), 50);
};

const closeModal = modalClass => {
	const el = document.querySelector(`.${modalClass}`);
	el.style.opacity = 0;
	setTimeout(() => {
		el.style.display = "none";
	}, 500);
};

const setupScheduleDemoModal = () => {
	const scheduleButtons = [".schedule-button", ".outcomes-schedule-demo"]
		.map(c => Array.from(document.querySelectorAll(c)))
		.flat();
	for (const scheduleButton of scheduleButtons) {
		scheduleButton.onclick = () => {
			openModal("schedule-modal");
		};
	}

	// close schedule modal if a. is displaying and b. user clicked out
	document.addEventListener("click", e => {
		// if modal open
		const scheduleModal = document.querySelector(".schedule-modal");
		const thanksModal = document.querySelector(".thanks-modal");

		if (scheduleModal) {
			if (
				scheduleModal.style.display &&
				scheduleModal.style.display !== "none"
			) {
				// if the click is outside the modal (the modal is a child), close it
				if (
					e.target.classList.contains("schedule-close") ||
					e.target.classList.contains("schedule-outer-container") ||
					e.target.contains(scheduleModal)
				) {
					closeModal("schedule-modal");
				}
			}
		}

		if (thanksModal) {
			if (thanksModal.style.display && thanksModal.style.display !== "none") {
				// if the click is outside the modal (the modal is a child), close it
				if (
					e.target.classList.contains("thanks-close") ||
					e.target.contains(thanksModal)
				) {
					closeModal("thanks-modal");
				}
			}
		}
	});

	const searchParams = new URLSearchParams(window.location.search);
	const showThanks = searchParams.get("view") === "thanks";
	if (showThanks) {
		openModal("thanks-modal");
	}
	const showModal = searchParams.get("schedule-demo") === "1";
	if (showModal) {
		// Remove `schedule-demo` from query parameters
		searchParams.delete("schedule-demo");
		const newUrl = searchParams.toString()
			? `${window.location.pathname}?${searchParams}`
			: window.location.pathname;

		window.history.replaceState({}, "", newUrl);
		openModal("schedule-modal");
	}
};

module.exports = {
	setupScheduleDemoModal,
};
